import { getAdminUsers, deleteAdminUser, createAdminUser, updateAdminUser } from "../../api/adminUser";

const adminUser = {
    namespaced: true,
    state: {
        adminUsers: {
            total: 0,
            count: 0,
            data: [],
        },
    },
    getters: {
        getAdminUser: (state) => (id) => {
            return state.adminUsers.data.find((u) => u._id === id);
        },
    },
    mutations: {
        SET_ADMIN_USERS: (state, payload) => {
            state.adminUsers = payload;
        },
        ADD_ADMIN_USER: (state, payload) => {
            state.adminUsers.data.push(payload);
            state.adminUsers.total++;
        },
        UPDATE_ADMIN_USER: (state, payload) => {
            let adminUser = state.adminUsers.data.findIndex((p) => p._id === payload._id);
            state.adminUsers.data[adminUser] = payload;
        },
        REMOVE_ADMIN_USER: (state, id) => {
            state.adminUsers.data = state.adminUsers.data.filter((u) => u._id !== id);
            state.adminUsers.total--;
        },
    },
    actions: {
        getAdminUsers({ commit }, payload) {
            return getAdminUsers(payload.perPage, payload.page).then((response) => {
                commit("SET_ADMIN_USERS", response.data);
            });
        },
        getAdminUser({ state }, id) {
            return state.adminUsers.data.find((u) => u._id === id);
        },
        createAdminUser({ commit }, payload) {
            return createAdminUser(payload).then((response) => {
                commit("ADD_ADMIN_USER", response.data);
            });
        },
        updateAdminUser({ commit }, payload) {
            return updateAdminUser(payload._id, payload).then((response) => {
                commit("UPDATE_ADMIN_USER", response.data);
            });
        },
        deleteAdminUser({ commit }, id) {
            commit("REMOVE_ADMIN_USER", id);
            return deleteAdminUser(id);
        },
    },
};

export default adminUser;
